/**
 * Convert markdown-style text to HTML
 * Handles basic markdown formatting
 */
export const markdownToHtml = (text) => {
  if (!text || typeof text !== 'string') return ''
  
  let html = text
  
  // Convert markdown links to HTML (handle both formats)
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
  
  // Convert **bold** to <strong> (non-greedy)
  html = html.replace(/\*\*([^*]+?)\*\*/g, '<strong>$1</strong>')
  
  // Split into paragraphs (double newlines)
  const paragraphs = html.split(/\n\n+/)
  
  // Process each paragraph
  html = paragraphs.map(para => {
    para = para.trim()
    if (!para) return ''
    
    // Check if it's a list
    if (para.match(/^\* /m)) {
      // Convert list items
      const listItems = para.split(/\n(?=\* )/).map(item => {
        item = item.replace(/^\* /, '')
        // Process bold/italic in list items
        item = item.replace(/\*\*([^*]+?)\*\*/g, '<strong>$1</strong>')
        return `<li>${item}</li>`
      }).join('')
      return `<ul>${listItems}</ul>`
    }
    
    // Process bold/italic in regular paragraphs
    para = para.replace(/\*\*([^*]+?)\*\*/g, '<strong>$1</strong>')
    
    // Convert single newlines to <br> within paragraphs
    para = para.replace(/\n(?!\n)/g, '<br>')
    
    // Wrap in paragraph
    return `<p>${para}</p>`
  }).join('')
  
  return html
}

